// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.series[data-v-1d783a47] {\n  width: 100%;\n  margin-bottom: 16px;\n}\n.series__errors[data-v-1d783a47] {\n  display: block;\n  width: 100%;\n  margin: 0 15px;\n  padding-bottom: 10px;\n  color: #f04;\n  font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
